export default "dist/images/block-container-basic.819c1fd.png";